import React from 'react';

const BlockingOverlay = ({ shouldDisplay = false }) => {
    return shouldDisplay ? (
        <div className="blockingOverlay" role="status" aria-live="polite" aria-busy="true">
            <div className="blockingOverlay__spinner" aria-hidden="true"></div>
            <span className="blockingOverlay__text">Loading user data...</span>
        </div>
    ) : null;
}

export default BlockingOverlay;